import { render, staticRenderFns } from "./EditExpenseCategory.vue?vue&type=template&id=be453752&"
import script from "./EditExpenseCategory.vue?vue&type=script&lang=js&"
export * from "./EditExpenseCategory.vue?vue&type=script&lang=js&"
import style0 from "./EditExpenseCategory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports